import React from 'react';
import { getVisuelUrl } from '../../utils/visuelMagasin';

/**
 * SCD R2 — Affiche le visuel photoréaliste du magasin.
 * 30/06 — plus aucun calque superposé (nom/logo retirés à la demande user).
 */
export const VisuelMagasin = ({ localisationId, typeId, secteurId, positionnement = 'coeur', className = '', testId = 'visuel-magasin' }) => {
  const url = getVisuelUrl({ localisationId, typeId, secteurId, positionnement });
  if (!url) return null;
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={testId}>
      <img src={url} alt="Visuel du magasin" loading="lazy" className="w-full h-full object-cover" />
    </div>
  );
};
